import { showCustomToast } from 'common/components/CustomToast/utils';
import { ApolloQueryResult, useMutation } from '@apollo/client';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { EntityAction } from 'common/types/utility';
import React from 'react';
import NOTIFY_CYCLE_ACTIVATE from './NotifyTimeActivation.graphql';

import { NotificationCycleRowItem } from '..';
import { NotifyTimeActivation, NotifyTimeActivationVariables } from './__generated__/NotifyTimeActivation';
import { ActivateNotifyCycleModal } from './ActivateNotifyCycleModal';
import { NotifyTimes, NotifyTimesVariables } from '../__generated__/NotifyTimes';



interface ActivateNotifyCycleProps {
  selectedRows: NotificationCycleRowItem[];
  refetch: (
    variables?: Partial<NotifyTimesVariables>
  ) => Promise<ApolloQueryResult<NotifyTimes>>;
}

export const ActivateNotifyCycle: React.FC<ActivateNotifyCycleProps> = ({
  selectedRows,
  refetch
}) => {
  const [activateNotifyCycle] = useMutation<
    NotifyTimeActivation,
    NotifyTimeActivationVariables
  >(NOTIFY_CYCLE_ACTIVATE, { errorPolicy: 'all' });

  const _onConfirm = async (isActive: boolean) => {
    const entityDelete: EntityDeleteInput[] = selectedRows.map((item) => {
      return { id: item.id, rowTimestamp: item._rowTimestamp! };
    });
    const { errors } = await activateNotifyCycle({
      variables: {
        input: {
          isActivationRequired: isActive,
          entityDelete,
        },
      },
    });

    if (errors?.length) {
      showCustomToast({
        content: errors[0].message,
        appearance: 'error',
      });
    } else {
      const isPlural = entityDelete.length > 1;

      showCustomToast({
        content: isActive
          ? `Notify cycle${isPlural ? 's' : ''} activated successfully.`
          : `Notify cycle${isPlural ? 's' : ''} deactivated successfully.`,
        appearance: 'success',
      });

      await refetch();
    }
  };

  return (
    <ActivateNotifyCycleModal
      action={EntityAction.Confirm}
      visible={!!selectedRows.length}
      onConfirm={_onConfirm}
    />
  );
};
